/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Cancel_PickupInputs */

const en_orders_cancel_pickup = /** @type {(inputs: Orders_Cancel_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel Pickup`)
};

const es_orders_cancel_pickup = /** @type {(inputs: Orders_Cancel_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar recoleccion`)
};

/**
* | output |
* | --- |
* | "Cancel Pickup" |
*
* @param {Orders_Cancel_PickupInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_cancel_pickup = /** @type {((inputs?: Orders_Cancel_PickupInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Cancel_PickupInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_cancel_pickup(inputs)
	return es_orders_cancel_pickup(inputs)
});